<template>
  <input
    type="search"
    @input="input"
    :value="value"
    class="search-box"
    :placeholder="placeholder"
    :class="{ 'leads-search': leadSearch }"
  >
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },

    leadSearch: {
      type: Boolean,
      required: false,
      default: true,
    },

    placeholder: {
      type: String,
      required: false,
      default: 'Digite para pesquisar',
    },
  },

  methods: {
    input: _.debounce(function (event) {
      this.$emit('input', event.target.value);
    }, 250),
  },
};
</script>

<style lang="scss">
  .search-box {
    display: inline-block;
    background: transparent;
    border: none;
    color: #F6F5F8;
    border-bottom: 1px solid #F6F5F8;
    width: 300px;
    padding: 0.375rem 0.75rem;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.5;
    outline: 0;

    &::placeholder {
      color: #F6F5F8;
    }
  }
</style>
